import type { Product } from '@c214/shared';
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../lib/api';

export const PRODUCTS_QUERY_KEY = ['products'] as const;

export function useProducts() {
  return useQuery({
    queryKey: PRODUCTS_QUERY_KEY,
    queryFn: async () => (await apiGet<{ products: Product[] }>('/api/products')).products,
  });
}

export function useProduct(id: number) {
  return useQuery({
    queryKey: ['product', id],
    queryFn: () => apiGet<Product>(`/api/products/${id}`),
    enabled: Number.isFinite(id) && id > 0,
  });
}
